import { render, staticRenderFns } from "./myOrderDetail.vue?vue&type=template&id=2601f390&scoped=true&"
import script from "./myOrderDetail.vue?vue&type=script&lang=js&"
export * from "./myOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./myOrderDetail.vue?vue&type=style&index=0&id=2601f390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601f390",
  null
  
)

export default component.exports